import {ResourceParams} from "../resources";

export type MarketplaceManagerResourceType =
  'hypotheses' |
  'notes' |
  'rrc-controls' |
  'rrc-limits' |
  'wildberries-product-cards' |
  'ozon-products' |
  'competitor-brands' |
  'product-cards' |
  'competitor-article-prices' |
  'competitor-articles';

export const marketplaceManagerResources: {
  [key in MarketplaceManagerResourceType]: ResourceParams
} = {
  'hypotheses': {
    key: 'hypotheses',
    name: 'Книга Гипотез',
    path: 'hypotheses'
  },
  'notes': {
    key: 'notes',
    name: 'Заметки',
    path: 'notes'
  },
  'rrc-controls': {
    key: 'rrc-controls',
    name: 'Контроль РРЦ 24/7',
    path: 'rrc-controls'
  },
  'rrc-limits': {
    key: 'rrc-limits',
    name: 'Лимиты РРЦ',
    path: 'rrc-limits'
  },
  'wildberries-product-cards': {
    key: 'wildberries-product-cards',
    name: 'Артикулы Wildberries',
    path: 'wildberries-product-cards'
  },
  'ozon-products': {
    key: 'ozon-products',
    name: 'Артикулы Ozon',
    path: 'ozon-products'
  },
  'competitor-brands': {
    key: 'competitor-brands',
    name: 'Бренды конкурентов',
    path: 'competitor-brands'
  },
  'product-cards': {
    key: 'product-cards',
    name: 'Карты продуктов',
    path: 'product-cards'
  },
  'competitor-article-prices': {
    key: 'competitor-article-prices',
    name: 'Цены по товарам конкурентов',
    path: 'competitor-article-prices'
  },
  'competitor-articles': {
    key: 'competitor-articles',
    name: 'Артикулы конкурентов',
    path: 'competitor-articles'
  }
}
